import React from 'react';
import { motion } from 'framer-motion';
import { BetaSignupForm } from '../components/form/BetaSignupForm';
import { DashboardTitle } from '../components/DashboardTitle';

export const SignupPage: React.FC = () => {
  return (
    <div className="space-y-6 pb-12"> {/* Added pb-12 for bottom padding */}
      <DashboardTitle 
        title="B E T A  S I G N U P" 
        subtitle="Join the Future of Life Optimization"
      />
      <div className="max-w-4xl mx-auto px-4"> {/* Added container with padding */}
        <motion.div 
          className="glass p-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center space-x-4 mb-8">
            <div className="p-3 rounded-lg bg-neon-green/20">
              <div className="w-6 h-6 text-neon-green">🚀</div>
            </div>
            <div>
              <h2 className="text-xl font-bold">Beta Program Application</h2>
              <p className="text-gray-400">Join us in shaping the future of personal optimization</p>
            </div>
          </div>

          <BetaSignupForm />
        </motion.div>
      </div>
    </div>
  );
};